import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { CmsModule as ACCmsModule } from '@appcatalyst/ng-cms-core-lib';
import { CoreModule as ACCoreModule } from '@appcatalyst/ng-cms-core-lib';
import { ACAuthService, ACResourceService, MenuService, MenuItem, FilteredListConfig } from "@appcatalyst/ng-cms-core-lib";

import { AdminRoutingModule, routedComponents } from "./admin-routing.module";
import { LogsResolve } from '@appcatalyst/ng-cms-core-lib';
import { LogsService } from '@appcatalyst/ng-cms-core-lib';
import { SourcesComponent } from './sources/sources.component';
import { SourceComponent } from './source/source.component';
import { PluginsComponent } from './plugins/plugins.component';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    ACCmsModule,
    ACCoreModule,
    AdminRoutingModule,
    ReactiveFormsModule
  ],
  providers: [
    FilteredListConfig,
    LogsService,
    LogsResolve,
  ],
  declarations: [
    routedComponents,
    SourcesComponent,
    SourceComponent,
    PluginsComponent
  ]
})
export class AdminModule {
  constructor(auth: ACAuthService, cms: ACResourceService, private menuService: MenuService) {
    this.menuService = menuService
    this.menuService.addMenu('topbar-right', [
      new MenuItem({ title: 'Administrator', type: 'dropdown', parentId: 'admin', roles: ['Global.Admin', 'Global.Staff'] })
    ])
    this.menuService.addDropdownItems('topbar-right', 'admin', [
      new MenuItem({ title: 'Sources', type: 'button', route: 'sources' }),
      new MenuItem({ title: 'Logs', type: 'button', route: 'logs' })
    ])
  }
}
